<template>
  <div id="container" class="mainBox">
    <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->
      <nyTit pathUrl='/suyuan' />
      <div class="content">
        <!-- 左 -->
        <div class="left_txts">
          <div class="left_txts_sub">
            <div class="left_txts_sub_A">
              <div class="subTit1"><span>市场大盘</span></div>
              <div class="left_txts_sub_A_info">
                <div class="left_txts_sub_A_info_item" v-for="(item,index) in state.leftData1" :key="index">
                  <div class="left_txts_sub_A_info_item_top">
                    <img :src="item.icon" class="icon" />
                    <div class="left_txts_sub_A_right">
                      <h5>{{item.name}}</h5>
                      <span>{{item.value}}</span>
                    </div>
                  </div>
                  <div class="numBox">
                    <div class="numBoxItem">环比：<i :class="item.hb<=0?'color1':'color2'">{{item.hb}}%</i><img src="../assets/img/nyhongshu/xj.png" v-if="item.hb<0" /><img src="../assets/img/nyhongshu/ss.png" v-if="item.hb>0"  /> </div>
                    <div class="numBoxItem">同比：<i :class="item.tb<=0?'color1':'color2'">{{item.tb}}%</i><img src="../assets/img/nyhongshu/xj.png" v-if="item.tb<0" /><img src="../assets/img/nyhongshu/ss.png" v-if="item.tb>0"  /> </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="left_txts_sub_B">
              <div class="subTit1"><span>行情走势</span></div>
              <div class="subTit_tit"><span>全国红薯价格走势（元 / 斤）</span><span><img src="../assets/img/nyhongshu/ai.png" />Ai图表分析 </span></div>
              <div class="echarts"><LeftLine /></div>
            </div>
            <div class="left_txts_sub_C">
              <div class="subTit_tit"><span>全国红薯主要售卖品种年度交易份额变趋势</span><span><img src="../assets/img/nyhongshu/ai.png" />Ai图表分析 </span></div>
              <div class="tabList"><div class="tabItem" :class="{tabItem1:state.leftTabIndex==index}" v-for="(item,index) in state.leftData3" :key="index" @click="tabClick(index)">{{item.name}}</div></div>
              <div class="echarts" v-if="state.showDiv"><LeftLine2 :listData="state.leftData3[state.leftTabIndex].list" :time="state.leftData3[state.leftTabIndex].time" /></div>
            </div>

          </div>
          <div class="left_txts_sub">
            <div class="left_txts_sub_D">
              <div class="subTit1"><span>种植预测</span></div>
              <div class="subTit_tit"><span>全国红薯后市行情分析</span><span><img src="../assets/img/nyhongshu/ai.png" />Ai图表分析 </span></div>
              <div class="echarts"><LeftRightPie :listData="state.leftPieData" /></div>
            </div>
            <div class="left_txts_sub_E">
              <div class="subTit1"><span>地域分析</span></div>
              <div class="subTit_tit"><span>全国红薯主要售卖品种年度交易份额变趋势</span><span><img src="../assets/img/nyhongshu/ai.png" />Ai图表分析 </span></div>
              <div class="left_txts_sub_E_info">
                <div class="left_txts_sub_E_info_left">
                  <div class="left_right_tab">
                    <div class="left">全国红薯交易占比排名前10的地域</div>
                    <div class="right"><div v-for="(item,index) in state.leftRightData1" class="item" :class="{item1:state.leftRightIndex==index}" @click="clickJy(index)">{{item.name}}</div></div>
                  </div>
                  <div class="echarts" v-if="state.showDiv1"><LeftBar :listData="state.leftRightData1[state.leftRightIndex].data" /></div>
                </div>
                <div class="left_txts_sub_E_info_right">
                  <div class="left_right_tab"><div class="left">全国红薯流向占比</div></div>
                  <div class="echarts"><LeftBar1 /></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 中 -->
        <div class="middle_txts">
          <div class="map"><dv-flyline-chart-enhanced :config="state.config" :dev="true" style="width: 100%;height: 100%" /></div>
          <div class="middle_nav"><navItem /></div>
        </div>
        <!-- 右 -->
         <div class="right_txts">
            <div class="right_txts_top">
              <div class="subTit1 subTit2"><span>品种结构</span></div>
              <div class="subTit_tit"><span>全国红薯主要品种分布</span><span><img src="../assets/img/nyhongshu/ai.png" />图表分析 </span></div>
              <div class="right_txts_top_info">
                <div class="right_txts_top_item" v-for="(item,index) in state.rightData1List" :key="index"><RightPie :listData="item" /></div>
              </div>
            </div>
           <div class="right_txts_bottom">
             <div class="right_txts_bottom_left">
               <div class="subTit_tit"><span>全国红薯主要售卖品种年度交易份额变趋势</span><span><img src="../assets/img/nyhongshu/ai.png" />Ai图表分析 </span></div>
               <div class="echarts"><RightLine /></div>
             </div>
             <div class="right_txts_bottom_right">
               <div class="subTit1"><span>红薯近30天商机分析</span></div>
               <div class="right_txts_bottom_right_info">
                   <div v-for="(item,index) in state.rightDataTxtList" :key="item.id" class="scroll_item">{{index+1}}、{{item.tit}}</div>
               </div>
             </div>
           </div>
        </div>
      </div>

  </div>
<!--  <div class="footer">本产品由来村网提供技术支持</div>-->
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";
import nyTit from "@/components/nyTit.vue";
import navItem from '@/components/nyNav'
import RightPie from "@/components/nyhongshu/RightPie";
import RightLine from "@/components/nyhongshu/RightLine"
import LeftLine from "@/components/nyhongshu/LeftLine"
import LeftLine2 from "@/components/nyhongshu/LeftLine2"
import LeftBar from "@/components/nyhongshu/LeftBar"
import LeftRightPie from "@/components/nyhongshu/LeftRightPie"
import LeftBar1 from "@/components/nyhongshu/LeftBar1"
import txtScroll from "@/components/xiaofeiChanpin/txtScroll.vue"

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";



  // const timer = ref(null);
  const router = useRouter();
const canvas = ref(null);

  const state = reactive({
    leftData1:[{name:"采购热度",value:12175,hb:"39",tb:"-15",icon:require('../assets/img/nyhongshu/cg.png')},{name:"交易热度",value:11510,hb:"71",tb:"-6",icon:require('../assets/img/nyhongshu/jy.png')},{name:"售卖热度",value:4498,hb:"29",tb:"15",icon:require('../assets/img/nyhongshu/sm.png')}],
    leftData2:[],
    leftData3:[
      {
        name:"全国红薯热门供应省份价格走势（元/斤）",
        list:[
          {name:"山东",value:[1.6,1.5,1.56,1.56,1.7,1.9]},
          {name:"河南",value:[1.25,1.3,1.2,1.3,1.4,1.5]},
          {name:"河北",value:[1.36,1.2,1.3,1.39,1.46,1.4]},
          {name:"湖北",value:[1.4,1.36,1.38,1.38,1.6,1.3]},
          {name:"广东",value:[2.00,1.8,1.78,1.75,1.62,1.68]},
        ],
        time: [ '2023/10', '2023/11', '2023/12', '2024/01', '2024/02', '2024/03']
      },
      {
        name:"全国红薯品种价格走势（元/斤）",
        list:[
          {name:"烟薯",value:[1.6,1.5,1.56,1.56,1.7,1.9]},
          {name:"西瓜红",value:[1.25,1.3,1.2,1.3,1.4,1.5]},
          {name:"商暑",value:[1.36,1.2,1.3,1.39,1.46,1.4]},
          {name:"蜜薯",value:[1.4,1.36,1.38,1.38,1.6,1.3]},
          {name:"济薯",value:[2.00,1.8,1.78,1.75,1.62,1.68]},
        ],
        time: [ '2023/10', '2023/11', '2023/12', '2024/01', '2024/02', '2024/03']
      }
    ],
    leftTabIndex:0,
    leftRightData1:[
      {name:"全国",data:{name:['广东', '江苏', '浙江', '湖南', '四川','湖北', '安徽'],value:[18, 11, 10, 9, 8,7,6.5]}},
      {name:"市级",data:{name:['广东1', '江苏', '浙江', '湖南', '四川','湖北', '安徽'],value:[8,7,6.5,6.2,6,5.9,5.6]}}
    ],
    leftRightIndex:0,
    leftPieData:[{ name:"看涨",value:50 },{ name:"看平",value:26.5 },{ name:"看跌",value:23.5 }],
    rightData1List:[
      {name:"售卖",list:[ {name: '烟薯', value: 25.7 },{ name: '商薯', value: 3.7 }, { name: '蜜薯', value: 12 }, { name: '龙薯', value: 8.1 }, { name: '济薯', value: 7.1 }, { name: '其他', value: 24.8 }]},
      {name:"采购",list:[ {name: '烟薯', value:30 }, { name: '西瓜红', value: 26 }, { name: '蜜薯', value: 8.3 }, { name: '龙薯', value: 7 },{ name: '商薯', value: 5.4 }, { name: '其他', value: 23.3 }]},
      {name:"交易",list:[ {name: '烟薯', value: 68.6 },{ name: '商薯', value: 9.9 }, { name: '蜜薯', value: 9.5 }, { name: '板栗薯', value: 5.1 }, { name: '黄心红薯', value: 3 }, { name: '其他', value: 9.1 }]},
    ],
    rightDataTxtList:[
      {tit:"近半年红薯售卖热度环比增29%，同比升159%;购买热度环比增39%，同比降15%;交易热度环比增71%，同比降6%，显示销售增长迅速，购买和交易热度波动较大。"},
      {tit:"红薯售卖排名前三省份为山东(26.1%6)、河南(14.5%)、河北(12.1%6)。山东份额最高，为红薯销售主要省份。"},
      {tit:"红薯购买排名前三省份为广东(15.6%)、河南(11.9%)、山东(10.0%)。广东份额最高，为红薯购买主要省份。"},
      {tit:"红薯交易流向排名前三省份为广东(18.0%)、江苏(9.0%)、浙江(8.1%)。广东交易份额最高，为红薯消费主要地区。"},
      {tit:"售卖最多品种为烟著(25.7%)，购买最多为烟薯(30.0%)，交易最多为烟薯(68.6%)。烟著在红薯市场占据重要地位"},
      {tit:"近期红薯后市行情预测中，看涨占50.0%，看平占26.5%，看跌占23.5%。显示市场对红薯后市行情整体持乐观态度。"},
    ],
    startVal: 0,
    xsindex: 0,
    showDiv:true,
    showDiv1:true,
    config:{
      halo: {
        show: true,
        radius:30,
        color:"#58F9DB"
      },
      points: [
        {
          name: '郑州',
          coordinate: [0.73, 0.46],
          icon: {
            src:require( '../assets/img/nyhongshu/center.png'),
            width: 30,
            height: 30
          },
          halo: {
            show: true,
            radius:100,
            color:"#FF7723"
          },
        },
        {
          name: '新乡',
          coordinate: [0.82, 0.21]
        },
        {
          name: '焦作',
          coordinate: [0.69, 0.23]
        },
        {
          name: '开封',
          coordinate: [0.55, 0.70]
        },
        {
          name: '许昌',
          coordinate: [0.36, 0.11]
        },
        {
          name: '平顶山',
          coordinate: [0.28, 0.32]
        },
        {
          name: '洛阳',
          coordinate: [0.36, 0.17]
        },
        {
          name: '周口',
          coordinate: [0.31, 0.70]
        },
        {
          name: '漯河',
          coordinate: [0.21, 0.37]
        },
        {
          name: '南阳',
          coordinate: [0.48, 0.51]
        },
        {
          name: '信阳',
          coordinate: [0.77, 0.50]
        },
        {
          name: '驻马店',
          coordinate: [0.74, 0.54]
        },
        {
          name: '济源',
          coordinate: [0.37, 0.29]
        },
        // {
        //   name: '三门峡',
        //   coordinate: [0.20, 0.36]
        // },
        // {
        //   name: '商丘',
        //   coordinate: [0.76, 0.41]
        // },
        // {
        //   name: '鹤壁',
        //   coordinate: [0.59, 0.18]
        // },
        // {
        //   name: '濮阳',
        //   coordinate: [0.68, 0.17]
        // },
        // {
        //   name: '安阳',
        //   coordinate: [0.59, 0.10]
        // }
      ],
      lines: [
        {
          source: '郑州',
          target: '新乡'
        },
        {
          source: '郑州',
          target: '焦作'
        },
        {
          source: '郑州',
          target: '开封'
        },
        {
          source: '郑州',
          target: '许昌'
        },
        {
          source: '郑州',
          target: '平顶山'
        },
        {
          source: '郑州',
          target: '洛阳'
        },
        {
          source: '郑州',
          target: '周口'
        },
        {
          source: '郑州',
          target: '漯河'
        },
        {
          source: '郑州',
          target: '南阳'
        },
        {
          source: '郑州',
          target: '信阳'
        },
        {
          source: '郑州',
          target: '驻马店'
        },
        {
          source: '郑州',
          target: '济源'
        },
        // {
        //   source: '三门峡',
        //   target: '郑州'
        // },
        // {
        //   source: '商丘',
        //   target: '郑州'
        // },
        // {
        //   source: '鹤壁',
        //   target: '郑州'
        // },
        // {
        //   source: '濮阳',
        //   target: '郑州'
        // },
        // {
        //   source: '安阳',
        //   target: '郑州'
        // }
      ],
      line:{
        width:4,
        // color:"#f00"
      },
      icon: {
        show: true,
        width: 16,
        height: 22,
        src: require( '../assets/img/nyhongshu/icon.png')
      },
      bgImgSrc: require('../assets/img/nyhongshu/map.png'),
    }
  });
  // 交易份额
function clickJy(index){
  state.showDiv1 = false; // 点击后先隐藏div
  state.leftRightIndex = index
  setTimeout(() => {
    state.showDiv1 = true; // 200ms后再重新显示div（模拟刷新）
  }, 200);
}
  function tabClick(index){
    state.showDiv = false; // 点击后先隐藏div
    state.leftTabIndex = index
    setTimeout(() => {
      state.showDiv = true; // 200ms后再重新显示div（模拟刷新）
    }, 200);
  }
  // 在 onMounted 中初始化地图
  onMounted(() => {

  });


    onUnmounted(() => {});
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });

</script>
<style lang="less" scoped>
 .footer{
    width: 100%;
    height: 30px;
    line-height: 30px;
    color: #fff;
    text-align: center;
    font-size: 30px;
    position: fixed;
    bottom: 30px;
    left: 0;
    z-index: 10000;
    font-weight: bold;
    }
body {
  background-size: cover;
  line-height: 1.15;
}
::v-deep .d-play-btn {
  width: 50px !important;
  height: 50px !important;
}
::v-deep .d-player-state {
  top: 50%;
  margin-top: -25px;
}
::v-deep .d-icon {
  font-size: 20px !important;
}
::v-deep .d-player-wrap .d-player-control {
  height: 30px;
}

.mainBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  overflow: hidden;
  background: url("../assets/img/plantmoxing/new/bj.png") no-repeat top center;
  background-size: 100% 100%;
  .content {
    width: 100%;
    height: calc(100% - 150px);
    position: absolute;
    top: 150px;
    // border: #fff 1px solid;
    display: flex;
    flex-flow: row;
    padding-bottom: 100px;
    .subTit1{
      width: 100%;
      height: 130px;
      line-height: 40px;
      background: url("../assets/img/nyhongshu/bt3.png") no-repeat center bottom;
      color: #fff;
      font-size: 40px;
      margin: 20px auto 0;
      span{
        background: linear-gradient(to bottom, #fff 25%, #FFD791 95%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-weight: bold;


      }
    }
    .subTit2{
      height: 195px;
      line-height: 30px;
      background: url("../assets/img/nyhongshu/bt2.png") no-repeat;
    }
    .subTit_tit{
      display: flex;
      justify-content: space-between;
      position: relative;
      height: 61px;
      line-height: 61px;
      padding: 0 30px 0 30px;
      span:first-child{
        color: #1FE4CC;
        font-size: 26px;
      }
      span:last-child{
        display: flex;
        font-size: 26px;
        color: #fff;
        align-items: center;
        img{
          width:28px ;
          height: 28px;
          margin-right: 10px;
        }
      }
    }
    .subTit_tit::before{
      content: "";
      width: 4px;
      height: 21px;
      background: #1FE4CC;
      position: absolute;
      top: 20px;
      left: 10px;
    }
    .left_txts {
      width: 2127px;
      height: 100%;
      margin: 0 10px;
      display: flex;
      justify-content: space-between;
      .left_txts_sub{
        width: 1026px;
        height: 100%;
        //border: 1px solid #f00;
        display: flex;
        flex-direction: column;
        .left_txts_sub_A{
          width: 100%;
          height: 300px;
          .left_txts_sub_A_info{
            width: 100%;
            flex: 1;
            display: flex;
            .left_txts_sub_A_info_item{
              width: 33%;
              display: flex;
              flex-direction: column;
              padding: 0 30px;
              .left_txts_sub_A_info_item_top{
                display: flex;
                justify-content: center;
                align-items: center;
                height: 95px;
                .icon{
                  width: 95px;
                  height: 93px;
                }
                .left_txts_sub_A_right{
                  margin-left: 20px;
                  text-align: left;
                  h5{
                    color: #fff;
                    font-size: 26px;
                    font-weight: normal;
                  }
                  span{
                    font-size: 30px;
                    color: #00E0CD;
                  }
              }
              }
              .numBox{
                display: flex;
                justify-content: space-between;
                margin-top: 10px;
                .numBoxItem{
                  display: flex;
                  align-items: center;
                  font-size: 22px;
                  color: #fff;
                  img{width: 24px;height:26px;}
                  .color1{color: #02D58A}
                  .color2{color: #D20202}
                }
              }
            }
          }
        }
        .left_txts_sub_B{
          width: 100%;
          height: 600px;
          display: flex;
          flex-direction: column;
          .left_txts_sub_B_info{
            width: 100%;
            flex: 1;
            display: flex;
            .left_txts_sub_B_item{
              flex: 1;
              height: 100%;
            }
          }
        }
        .left_txts_sub_C{
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          .tabList{
            height: 50px;
            display: flex;
            justify-content: space-between;
            padding: 0 20px;
            margin: 20px 0 0;
            .tabItem{
              background: rgba(42,130,96,0.06);
              box-shadow: inset 0px 1px 33px 0px rgba(29,143,110,0.35);
              border-radius: 0px 7px 7px 0px;
              border: 1px solid rgba(2,214,139,.5);
              color: rgba(31,228,204,.65);
              font-size: 26px;
              line-height: 50px;
              padding: 0 30px;
            }
            .tabItem1{
              background: rgba(42,130,96,0.06);
              box-shadow: inset 0px 1px 33px 0px rgba(29,143,110,0.5);
              border-radius: 0px 7px 7px 0px;
              border: 1px solid #02D68B;
              color: rgba(31,228,204,1);
            }
          }
        }
        .left_txts_sub_D{
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
        }
        .left_txts_sub_E{
          width: 100%;
          height: 860px;
          display: flex;
          flex-direction: column;
          .subTit_tit{
            //margin-top: -30px;
          }
          .left_txts_sub_E_info{
            width: 100%;
            flex: 1;
            display: flex;
            .left_txts_sub_E_info_left{
              flex: 1;
              height: 100%;
              display: flex;
              flex-direction: column;
            }
            .left_txts_sub_E_info_right{
              flex: 1;
              display: flex;
              flex-direction: column;
              margin-left: 20px;
              .left_right_tab{
                padding-left: 30px;
                //font-size: 26px;
              }
            }
            .left_right_tab{
              display: flex;
              justify-content: space-between;
              font-size: 22px;
              height: 44px;
              line-height: 36px;
              margin-top:20px;
              .left{color: #fff;line-height: 44px;}
              .right{
                display: flex;
                font-size: 20px;
                .item{
                  padding: 0 16px;
                  background: rgba(42,130,96,0.06);
                  box-shadow: inset 0px 1px 13px 0px rgba(29,143,110,.8);
                  border-radius: 20px 0 0 20px;
                  border: 4px solid #079667;
                  color: rgba(31,228,204,1);
                  opacity: .6;
                }
                .item:first-child{border-right:0}
                .item:last-child{
                  border-radius: 0 20px 20px 0;
                }
                .item1{
                  opacity: 1;
                }
              }
            }
          }
        }
      }
    }
    .middle_txts {
      flex: 1;
      height:calc(100% - 100px);
      margin: 50px 50px;
      padding: 100px 60px 0;
      //border: 1px solid;
      display: flex;
      flex-direction: column;
      .map{
        width: 100%;
        flex:1 ;
      }
      .middle_nav{
        //height: 200px;
      }
    }
  }
  .echarts{
    width: 100%;
    flex: 1;
  }

//右
    .right_txts {
      width: 2127px;
      height: 100%;
      margin: 0 10px;
      display: flex;
      flex-direction: column;
      .right_txts_top{
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        .right_txts_top_info{
          width: 100%;
          flex: 1;
          display: flex;
          padding-right: 50px;
          .right_txts_top_item{
            flex: 1;
            height: 100%;
          }
        }
        .subTit_tit{
          margin-top: -70px;
        }
      }
      .right_txts_bottom{
        width: 100%;
        height: 664px;
        display: flex;
        .right_txts_bottom_left{
          flex: 1;
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        .right_txts_bottom_right{
          width: 1022px;
          height: 100%;
          display: flex;
          flex-direction: column;
          .right_txts_bottom_right_info{
            width: 100%;
            flex: 1;
            ::v-deep .main_container{height: 100%;border:1px solid #f00}
            .scroll_item{
              height: 80px;
              line-height: 80px;
              overflow: hidden;
              font-size: 30px;
              padding: 0px 30px;
              text-align: left;
              color: rgba(255,255,255,.8);
              white-space: nowrap;
              text-overflow: ellipsis;
              cursor: pointer;
            }
          }

        }
      }
    }
  }

@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
@keyframes left1Img {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes titIcon {
  /*引用动画名称*/
  0% {
    transform: rotateY(0);
  }
  50% {
    transform: rotateY(180deg);
    animation-delay: 5s;
  }
  100% {
    transform: rotateY(0);
  }
}
</style>
